/** Slovenska množina: 1 / 2 / 3–4 / 5+ (npr. naloga, nalogi, naloge, nalog). */
export function plural(n: number, one: string, two: string, few: string, many: string): string {
  const mod = Math.abs(n) % 100;
  if (mod === 1) return one;
  if (mod === 2) return two;
  if (mod === 3 || mod === 4) return few;
  return many;
}

export const tasksWord = (n: number) => `${n} ${plural(n, 'naloga', 'nalogi', 'naloge', 'nalog')}`;
